import { render } from "./ViewProduitPage.vue?vue&type=template&id=1eec6197&ts=true"
import script from "./ViewProduitPage.vue?vue&type=script&lang=ts"
export * from "./ViewProduitPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__